import { getProductItems } from '../helpers/getProductItems'

import { usePaidSuccessfullyUrl } from './paidSuccess/paidSuccessfullyUrl'

import type { $Enums } from '@prisma/client'
import type { TPlatFormName } from '@/contexts/SiteSpecificContext/types'
import type { ISubCreateProps } from '../type'

import { api } from '@/utils/api'

export interface IGetPaymentLinkProps extends ISubCreateProps {
  cancelUrl: string
  action: 'create' | 'upgrade'
  platformName: TPlatFormName
}

export function useGetPaymentLink({
  appName,
}: {
  appName: $Enums.SubLogAppName
}) {
  const { getPaidSuccessfullyUrl } = usePaidSuccessfullyUrl()

  const { isLoading, mutateAsync } = api.subLog.getPaymentLink.useMutation()

  const getPaymentLink = async ({
    pricesId,
    cancelUrl,
    productPriceList,
    platformName,
    action,
  }: IGetPaymentLinkProps) => {
    const items = getProductItems({
      productPriceList,
      appName,
    })

    const itemsStr = JSON.stringify(items)

    const paidSuccessfullyUrl = getPaidSuccessfullyUrl({
      items: itemsStr,
      payment_platform: platformName,
      action,
    })

    const res = await mutateAsync({
      pricesId,
      successUrl: paidSuccessfullyUrl,
      cancelUrl,
      platformName,
    })
    return res
  }

  return { getPaymentLink, isFetching: isLoading, isLoading }
}
